"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SkipNavLink", {
  enumerable: true,
  get: function get() {
    return _skipNav.SkipNavLink;
  }
});
Object.defineProperty(exports, "SkipNavContent", {
  enumerable: true,
  get: function get() {
    return _skipNav.SkipNavContent;
  }
});

var _skipNav = require("@reach/skip-nav");

require("@reach/skip-nav/styles.css");